import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import { renderCell } from "../model";
import DoubleClickComponent from "../../DoubleClickComponent";
import "./styles.scss";
import { TablePropTypes } from "../../propTypes";

const Row = React.forwardRef(
  (
    {
      columns,
      onClickRowHandler,
      onDoubleClickRowHandler,
      isChecked,
      rowId,
      onSelectRowHandler,
      activeRow,
      selectable,
      applyRowStyles,
      row,
      rowIndex,
      ...props
    },
    ref
  ) => {
    const getClassnames = row => {
      const isActive = isEqual(activeRow, row);

      if (selectable && isChecked(row)) {
        return "mydpd-table-row-selected";
      } else if (isActive) {
        return "mydpd-table-row-active";
      }
    };

    return (
      <DoubleClickComponent
        ref={ref}
        key={row[rowId]}
        component="tr"
        onClick={onClickRowHandler(row)}
        onDoubleClick={onDoubleClickRowHandler(row)}
        className={classNames(
          "mydpd-table-row",
          getClassnames(row),
          applyRowStyles(row)
        )}
        {...props}
      >
        {columns.map((column, columnIndex) => {
          return (
            <td
              id={`${rowIndex}_${column.text}_${columnIndex}`}
              onClick={event => {
                column.onClick && column.onClick(event, row, rowIndex);
              }}
              key={column.geyKey ? column.geyKey(row) : columnIndex}
            >
              {renderCell(column, row, rowIndex, onSelectRowHandler, isChecked)}
            </td>
          );
        })}
      </DoubleClickComponent>
    );
  }
);

Row.propTypes = {
  ...TablePropTypes,
  activeRow: PropTypes.object.isRequired,
  onClickRowHandler: PropTypes.func,
  onSelectRowHandler: PropTypes.func,
  isChecked: PropTypes.func,
};

Row.defaultProps = {
  data: [],
  columns: [],
  applyRowStyles: () => [],
};

export default Row;
